var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNswDriverLicence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 116,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335 0v116H0V0h335z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 0c6.075 0 11 4.925 11 11v92c0 6.075-4.925 11-11 11H11c-6.075 0-11-4.925-11-11V11C0 4.925 4.925 0 11 0h148z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170 0v81c0 6.075-4.925 11-11 11H11C4.925 92 0 87.075 0 81V0h170z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.596 0l5.25 6.776V0H8.54v9.8H7.098L1.694 2.828V9.8H0V0h1.596z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282V7.49H5.026v-.924c-.504.602-1.274 1.078-2.408 1.078C1.232 7.644 0 6.846 0 5.362v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308V3.08c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462L.644.602C1.456.238 2.254 0 3.43 0zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504a4.696 4.696 0 0 0-1.68-.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718H9.548v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172H4.774V3.332c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172H0V.154h1.694v1.12C2.17.616 2.814 0 3.948 0c1.064 0 1.82.518 2.212 1.302C6.748.518 7.532 0 8.652 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.654 0c3.08 0 5.208 2.114 5.208 4.872V4.9c0 2.758-2.128 4.9-5.208 4.9H0V0zm0 1.568H1.722v6.664h1.932c2.058 0 3.402-1.386 3.402-3.304V4.9c0-1.918-1.344-3.332-3.402-3.332z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282V7.49H5.026v-.924c-.504.602-1.274 1.078-2.408 1.078C1.232 7.644 0 6.846 0 5.362v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308V3.08c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462L.644.602C1.456.238 2.254 0 3.43 0zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504a4.696 4.696 0 0 0-1.68-.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.632 0v2.03H4.62v1.456H2.632v3.626c0 .658.336.924.91.924.378 0 .714-.084 1.05-.252V9.17c-.42.238-.882.378-1.526.378-1.246 0-2.128-.546-2.128-2.17V3.486H0V2.03h.938V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.948 0c2.268 0 3.934 1.722 3.934 3.836v.028c0 2.1-1.68 3.85-3.962 3.85C1.666 7.714 0 5.992 0 3.892v-.028C0 1.75 1.68 0 3.948 0zM3.92 1.484c-1.358 0-2.226 1.064-2.226 2.352v.028c0 1.288.938 2.366 2.254 2.366 1.372 0 2.24-1.064 2.24-2.338v-.028c0-1.302-.938-2.38-2.268-2.38z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.206 0c.588 0 .994.084 1.372.196v1.428c-.336-.112-.63-.182-.994-.182-.644 0-.98.35-.98 1.12v.406h1.96v1.4H2.632v5.936H.938V4.368H0V2.954h.938v-.546c0-.812.21-1.428.602-1.82C1.932.196 2.478 0 3.206 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148H0V0h1.694zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366V6.51c0-1.428-.966-2.366-2.114-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.764 2.744v7.392H.07V2.744h1.694zM1.82 0v1.61H0V0h1.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 0l.202.003v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814H0V.143h1.694v1.666C2.156.703 3.01-.053 4.312.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.632 0v2.03H4.62v1.456H2.632v3.626c0 .658.336.924.91.924.378 0 .714-.084 1.05-.252V9.17c-.42.238-.882.378-1.526.378-1.246 0-2.128-.546-2.128-2.17V3.486H0V2.03h.938V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v3.962c.476-.686 1.162-1.288 2.31-1.288 1.666 0 2.632 1.12 2.632 2.828v4.718H4.942v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172H0V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.722 0v8.232h5.152V9.8H0V0h1.722z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.764 2.744v7.392H.07V2.744h1.694zM1.82 0v1.61H0V0h1.82z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85 0c1.386 0 2.254.518 2.954 1.274L5.74 2.408c-.518-.546-1.064-.924-1.904-.924-1.232 0-2.142 1.064-2.142 2.352v.028c0 1.316.91 2.366 2.212 2.366.798 0 1.386-.364 1.918-.91l1.022 1.008c-.728.812-1.582 1.386-3.024 1.386C1.624 7.714 0 5.992 0 3.892v-.028C0 1.764 1.624 0 3.85 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.004 0C5.67 0 6.636 1.12 6.636 2.828v4.718H4.942v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172H0V.154h1.694v1.134C2.17.602 2.856 0 4.004 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85 0c1.386 0 2.254.518 2.954 1.274L5.74 2.408c-.518-.546-1.064-.924-1.904-.924-1.232 0-2.142 1.064-2.142 2.352v.028c0 1.316.91 2.366 2.212 2.366.798 0 1.386-.364 1.918-.91l1.022 1.008c-.728.812-1.582 1.386-3.024 1.386C1.624 7.714 0 5.992 0 3.892v-.028C0 1.764 1.624 0 3.85 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.004 0C5.67 0 6.636 1.12 6.636 2.828v4.718H4.942v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172H0V.154h1.694v1.134C2.17.602 2.856 0 4.004 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.2c0 1.148.574 1.792 1.582 1.792.98 0 1.666-.672 1.666-1.82V0H6.65v7.392H4.942V6.244c-.476.7-1.162 1.302-2.31 1.302C.966 7.546 0 6.426 0 4.704V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718H9.548v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172H4.774V3.332c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172H0V.154h1.694v1.12C2.17.616 2.814 0 3.948 0c1.064 0 1.82.518 2.212 1.302C6.748.518 7.532 0 8.652 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148H0V0h1.694zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366V6.51c0-1.428-.966-2.366-2.114-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.054 0C6.86 0 7.952.63 8.89 1.526L7.784 2.8C7 2.072 6.16 1.582 5.04 1.582c-1.862 0-3.234 1.54-3.234 3.458v.028c0 1.918 1.358 3.472 3.234 3.472 1.204 0 1.974-.476 2.814-1.26L8.96 8.4c-1.022 1.064-2.142 1.736-3.976 1.736C2.128 10.136 0 7.91 0 5.096v-.028C0 2.282 2.086 0 5.054 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43 0c1.106 0 1.932.294 2.45.826.546.532.798 1.316.798 2.282V7.49H5.026v-.924c-.504.602-1.274 1.078-2.408 1.078C1.232 7.644 0 6.846 0 5.362v-.028c0-1.596 1.246-2.38 3.052-2.38.826 0 1.414.126 1.988.308V3.08c0-1.05-.644-1.61-1.834-1.61-.826 0-1.442.182-2.114.462L.644.602C1.456.238 2.254 0 3.43 0zm-.042 4.032c-1.092 0-1.736.462-1.736 1.232v.028c0 .714.63 1.12 1.442 1.12 1.12 0 1.974-.644 1.974-1.582v-.504a4.696 4.696 0 0 0-1.68-.294z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 0l.202.003v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814H0V.143h1.694v1.666C2.156.703 3.01-.053 4.312.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.644 0v10.22H5.95V8.988c-.546.77-1.316 1.386-2.52 1.386C1.694 10.374 0 8.988 0 6.538V6.51c0-2.45 1.666-3.836 3.43-3.836 1.218 0 1.988.602 2.52 1.302V0h1.694zM3.836 4.144c-1.162 0-2.128.896-2.128 2.366v.028c0 1.428.98 2.366 2.128 2.366 1.134 0 2.142-.952 2.142-2.366V6.51c0-1.428-1.008-2.366-2.142-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.004 0C5.67 0 6.636 1.12 6.636 2.828v4.718H4.942v-4.2c0-1.148-.574-1.806-1.582-1.806-.98 0-1.666.686-1.666 1.834v4.172H0V.154h1.694v1.134C2.17.602 2.856 0 4.004 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.2c0 1.148.574 1.792 1.582 1.792.98 0 1.666-.672 1.666-1.82V0H6.65v7.392H4.942V6.244c-.476.7-1.162 1.302-2.31 1.302C.966 7.546 0 6.426 0 4.704V0h1.694z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.652 0c1.61 0 2.59 1.022 2.59 2.828v4.718H9.548v-4.2c0-1.176-.546-1.806-1.498-1.806-.924 0-1.582.644-1.582 1.834v4.172H4.774V3.332c0-1.148-.56-1.792-1.498-1.792s-1.582.7-1.582 1.834v4.172H0V.154h1.694v1.12C2.17.616 2.814 0 3.948 0c1.064 0 1.82.518 2.212 1.302C6.748.518 7.532 0 8.652 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.694 0v4.06c.546-.77 1.316-1.386 2.52-1.386 1.736 0 3.43 1.372 3.43 3.836v.028c0 2.45-1.68 3.836-3.43 3.836-1.232 0-2.002-.616-2.52-1.302v1.148H0V0h1.694zm2.114 4.144c-1.148 0-2.156.952-2.156 2.366v.028c0 1.414 1.008 2.366 2.156 2.366 1.162 0 2.114-.91 2.114-2.366V6.51c0-1.428-.966-2.366-2.114-2.366z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.612 0c2.352 0 3.542 1.848 3.542 3.976 0 .154-.014.308-.028.476H1.694c.182 1.204 1.036 1.876 2.128 1.876.826 0 1.414-.308 2.002-.882l.994.882c-.7.84-1.666 1.386-3.024 1.386C1.652 7.714 0 6.16 0 3.878V3.85C0 1.736 1.498 0 3.612 0zm-.014 1.386c-1.036 0-1.764.798-1.918 1.946h3.794c-.112-1.092-.756-1.946-1.876-1.946z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.11 0l.202.003v1.792h-.098c-1.484 0-2.52.966-2.52 2.926v2.814H0V.143h1.694v1.666C2.156.703 3.01-.053 4.312.003z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.672 0C5.868 0 7.32 1.92 7.32 4.32v.024c0 2.4-1.464 4.344-3.672 4.344S0 6.768 0 4.368v-.024C0 1.944 1.464 0 3.672 0zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012 1.308 0 2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.288 0v8.46H1.824V1.5l-1.512.42L0 .72 2.268 0h1.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.684 0L1.26 11.112H0L5.424 0h1.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.672 0C5.868 0 7.32 1.92 7.32 4.32v.024c0 2.4-1.464 4.344-3.672 4.344S0 6.768 0 4.368v-.024C0 1.944 1.464 0 3.672 0zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012 1.308 0 2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.288 0v8.46H1.824V1.5l-1.512.42L0 .72 2.268 0h1.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.684 0L1.26 11.112H0L5.424 0h1.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.216 0C4.86 0 5.988 1.008 5.988 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996V8.52H0V7.356l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308-.768 0-1.296.42-1.932 1.26L.12 1.752C.924.636 1.716 0 3.216 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.672 0C5.868 0 7.32 1.92 7.32 4.32v.024c0 2.4-1.464 4.344-3.672 4.344S0 6.768 0 4.368v-.024C0 1.944 1.464 0 3.672 0zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012 1.308 0 2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.672 0C5.868 0 7.32 1.92 7.32 4.32v.024c0 2.4-1.464 4.344-3.672 4.344S0 6.768 0 4.368v-.024C0 1.944 1.464 0 3.672 0zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012 1.308 0 2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.288 0v8.46H1.824V1.5l-1.512.42L0 .72 2.268 0h1.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.216 0C4.86 0 5.988 1.008 5.988 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996V8.52H0V7.356l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308-.768 0-1.296.42-1.932 1.26L.12 1.752C.924.636 1.716 0 3.216 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664C1.752 8.544.708 7.932 0 7.068l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412H.468V0h5.556z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 0v5.364h1.2v1.212h-1.2V8.46H4.512V6.576H.276L0 5.52 4.668 0h1.26zM4.512 2.04l-2.76 3.324h2.76V2.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.832 0v1.308H2.076l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64V5.7c0 1.716-1.26 2.844-3.12 2.844C1.8 8.544.792 8.028 0 7.26l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588L.804 0h5.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888C.384 7.164 0 6.288 0 4.596v-.024C0 2.004 1.224 0 3.6 0zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.904 0v1.116L2.124 8.4H.456l3.768-7.104H0V0h5.904z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.204 0C4.884 0 6.12.972 6.12 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436S0 7.68 0 6.228v-.024c0-1.008.564-1.644 1.512-2.04C.804 3.792.288 3.228.288 2.292v-.024C.288.984 1.524 0 3.204 0zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26V6.12c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.368 0l4.5 5.808V0H7.32v8.4H6.084L1.452 2.424V8.4H0V0h1.368z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408H1.452c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188C1.416 6.612 0 5.28 0 3.324V3.3C0 1.488 1.284 0 3.096 0zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.412 0l1.404 4.368L8.112.024h1.464L7.5 6.408H6.192L4.776 2.076 3.348 6.408H2.052L0 .024h1.488L2.76 4.368 4.164 0h1.248z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.204 0C4.428 0 5.4.372 6.252 1.056L5.46 2.172c-.756-.564-1.512-.864-2.28-.864-.864 0-1.368.444-1.368.996v.024c0 .648.384.936 2.004 1.32 1.776.432 2.688 1.068 2.688 2.46v.024c0 1.572-1.236 2.508-3 2.508A5.174 5.174 0 0 1 0 7.296L.888 6.24c.804.696 1.62 1.092 2.652 1.092.912 0 1.488-.432 1.488-1.056v-.024c0-.6-.336-.924-1.896-1.284C1.344 4.536.336 4.008.336 2.46v-.024C.336.996 1.536 0 3.204 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.384 0c1.944 0 3.372 1.476 3.372 3.288v.024c0 1.8-1.44 3.3-3.396 3.3C1.428 6.612 0 5.136 0 3.336v-.024C0 1.5 1.44 0 3.384 0zM3.36 1.272c-1.164 0-1.908.912-1.908 2.016v.024c0 1.104.804 2.028 1.932 2.028 1.176 0 1.92-.912 1.92-2.004v-.024c0-1.116-.804-2.04-1.944-2.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.452 0v3.6c0 .984.492 1.536 1.356 1.536.84 0 1.428-.576 1.428-1.56V0H5.7v6.336H4.236v-.984c-.408.6-.996 1.116-1.98 1.116C.828 6.468 0 5.508 0 4.032V0h1.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.256 0v1.74H3.96v1.248H2.256v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216V7.86c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86V2.988H0V1.74h.804V0h1.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.452 0v3.396c.408-.588.996-1.104 1.98-1.104 1.428 0 2.256.96 2.256 2.424V8.76H4.236v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572V8.76H0V0h1.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.912 0l2.064 6.252L10.98.024h1.548l-2.916 8.46H8.328L6.264 2.448 4.2 8.484H2.928L0 .024h1.596L3.6 6.252 5.664 0h1.248z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94 0c.948 0 1.656.252 2.1.708.468.456.684 1.128.684 1.956V6.42H4.308v-.792c-.432.516-1.092.924-2.064.924C1.056 6.552 0 5.868 0 4.596v-.024c0-1.368 1.068-2.04 2.616-2.04.708 0 1.212.108 1.704.264V2.64c0-.9-.552-1.38-1.572-1.38-.708 0-1.236.156-1.812.396L.552.516A5.406 5.406 0 0 1 2.94 0zm-.036 3.456c-.936 0-1.488.396-1.488 1.056v.024c0 .612.54.96 1.236.96.96 0 1.692-.552 1.692-1.356v-.432a4.025 4.025 0 0 0-1.44-.252z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.452 0v8.76H0V0h1.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408H1.452c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188C1.416 6.612 0 5.28 0 3.324V3.3C0 1.488 1.284 0 3.096 0zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.568 0c.792 0 1.656.276 2.328.72L4.32 1.752c-.612-.372-1.26-.6-1.788-.6-.564 0-.888.264-.888.624V1.8c0 .468.684.66 1.428.9.924.288 1.968.708 1.968 1.848v.024c0 1.332-1.032 1.992-2.352 1.992A4.45 4.45 0 0 1 0 5.616l.648-.984c.696.516 1.428.78 2.076.78.624 0 .984-.264.984-.684v-.024c0-.492-.672-.66-1.416-.888-.936-.264-1.98-.648-1.98-1.86v-.024C.312.732 1.308 0 2.568 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.288 0v8.46H1.824V1.5l-1.512.42L0 .72 2.268 0h1.02z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.216 0C4.86 0 5.988 1.008 5.988 2.508v.024c0 1.32-.696 2.04-2.184 3.252l-1.728 1.44h3.996V8.52H0V7.356l2.892-2.46c1.152-.984 1.572-1.512 1.572-2.268 0-.828-.588-1.308-1.356-1.308-.768 0-1.296.42-1.932 1.26L.12 1.752C.924.636 1.716 0 3.216 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.024 0v1.104l-2.34 2.4c1.272.156 2.472.804 2.472 2.352v.024c0 1.548-1.188 2.664-2.94 2.664C1.752 8.544.708 7.932 0 7.068l1.032-.96c.6.708 1.272 1.104 2.208 1.104.828 0 1.452-.504 1.452-1.272v-.024c0-.828-.756-1.296-1.932-1.296h-.684l-.24-.924 2.268-2.412H.468V0h5.556z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.928 0v5.364h1.2v1.212h-1.2V8.46H4.512V6.576H.276L0 5.52 4.668 0h1.26zM4.512 2.04l-2.76 3.324h2.76V2.04z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.832 0v1.308H2.076l-.132 1.968c.396-.144.768-.24 1.332-.24 1.632 0 2.928.864 2.928 2.64V5.7c0 1.716-1.26 2.844-3.12 2.844C1.8 8.544.792 8.028 0 7.26l.912-1.068c.672.624 1.38 1.008 2.16 1.008 1.008 0 1.668-.576 1.668-1.452v-.024c0-.852-.72-1.392-1.74-1.392-.6 0-1.116.168-1.548.372l-.888-.588L.804 0h5.028z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 0c1.092 0 1.836.348 2.568.936l-.792 1.14c-.588-.456-1.08-.732-1.824-.732-1.464 0-1.992 1.524-2.016 2.676.492-.516 1.116-.852 2.016-.852 1.62 0 2.928.96 2.928 2.64v.024c0 1.668-1.356 2.856-3.12 2.856-1.032 0-1.776-.324-2.34-.888C.384 7.164 0 6.288 0 4.596v-.024C0 2.004 1.224 0 3.6 0zm-.312 4.404c-1.044 0-1.704.672-1.704 1.476v.024c0 .852.696 1.5 1.74 1.5s1.68-.648 1.68-1.512v-.024c0-.84-.672-1.464-1.716-1.464z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.904 0v1.116L2.124 8.4H.456l3.768-7.104H0V0h5.904z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.204 0C4.884 0 6.12.972 6.12 2.268v.024c0 .936-.516 1.5-1.224 1.872.924.42 1.512 1.02 1.512 2.016v.024c0 1.5-1.368 2.436-3.204 2.436S0 7.68 0 6.228v-.024c0-1.008.564-1.644 1.512-2.04C.804 3.792.288 3.228.288 2.292v-.024C.288.984 1.524 0 3.204 0zm0 4.848c-.996 0-1.752.504-1.752 1.272v.024c0 .684.648 1.26 1.752 1.26s1.764-.564 1.764-1.26V6.12c0-.768-.768-1.272-1.764-1.272zm0-3.612c-.9 0-1.5.528-1.5 1.164v.024c0 .732.636 1.248 1.5 1.248s1.5-.516 1.5-1.236v-.024c0-.648-.6-1.176-1.5-1.176z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.132 0c1.056 0 1.74.3 2.34.888.612.624 1.008 1.548 1.008 3.204v.024c0 2.7-1.332 4.572-3.6 4.572-1.164 0-1.98-.42-2.688-1.008l.804-1.128c.636.528 1.2.792 1.92.792 1.488 0 2.028-1.536 2.04-2.652-.468.564-1.116.9-1.98.9C1.188 5.592 0 4.548 0 2.928v-.024C0 1.26 1.272 0 3.132 0zm.012 1.272c-1.044 0-1.668.696-1.668 1.56v.024c0 .876.672 1.5 1.716 1.5 1.068 0 1.704-.696 1.704-1.512V2.82c0-.876-.684-1.548-1.752-1.548z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.672 0C5.868 0 7.32 1.92 7.32 4.32v.024c0 2.4-1.464 4.344-3.672 4.344S0 6.768 0 4.368v-.024C0 1.944 1.464 0 3.672 0zm-.024 1.332c-1.296 0-2.124 1.32-2.124 2.988v.024c0 1.656.84 3.012 2.148 3.012 1.308 0 2.124-1.344 2.124-2.988v-.024c0-1.656-.852-3.012-2.148-3.012z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52 0v5.544c0 .996-.3 1.74-.792 2.232-.492.492-1.2.744-2.04.744C1.392 8.52.552 7.92 0 7.164l.972-1.008c.492.636.984.996 1.692.996.792 0 1.332-.528 1.332-1.656V0H5.52z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.94 0c.948 0 1.656.252 2.1.708.468.456.684 1.128.684 1.956V6.42H4.308v-.792c-.432.516-1.092.924-2.064.924C1.056 6.552 0 5.868 0 4.596v-.024c0-1.368 1.068-2.04 2.616-2.04.708 0 1.212.108 1.704.264V2.64c0-.9-.552-1.38-1.572-1.38-.708 0-1.236.156-1.812.396L.552.516A5.406 5.406 0 0 1 2.94 0zm-.036 3.456c-.936 0-1.488.396-1.488 1.056v.024c0 .612.54.96 1.236.96.96 0 1.692-.552 1.692-1.356v-.432a4.025 4.025 0 0 0-1.44-.252z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56 0l1.788 4.704L4.992 0h1.512l-2.52 6.516C3.48 7.812 2.916 8.292 1.896 8.292c-.6 0-1.056-.144-1.5-.384l.492-1.08c.264.144.552.24.852.24.408 0 .66-.18.9-.72L0 0h1.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.332 0C5.88 0 6.816.54 7.62 1.308L6.672 2.4C6 1.776 5.28 1.356 4.32 1.356c-1.596 0-2.772 1.32-2.772 2.964v.024c0 1.644 1.164 2.976 2.772 2.976 1.032 0 1.692-.408 2.412-1.08l.948.96c-.876.912-1.836 1.488-3.408 1.488C1.824 8.688 0 6.78 0 4.368v-.024C0 1.956 1.788 0 4.332 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aG"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.512 2.352v6.336H.06V2.352h1.452zM1.56 0v1.38H0V0h1.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.256 0v1.74H3.96v1.248H2.256v3.108c0 .564.288.792.78.792.324 0 .612-.072.9-.216V7.86c-.36.204-.756.324-1.308.324-1.068 0-1.824-.468-1.824-1.86V2.988H0V1.74h.804V0h1.452z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aI"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.512 2.352v6.336H.06V2.352h1.452zM1.56 0v1.38H0V0h1.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aJ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.508 0v.996l-3.66 4.152h3.66v1.188H0V5.34l3.66-4.152H.132V0h5.376z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.096 0c2.016 0 3.036 1.584 3.036 3.408 0 .132-.012.264-.024.408H1.452c.156 1.032.888 1.608 1.824 1.608.708 0 1.212-.264 1.716-.756l.852.756c-.6.72-1.428 1.188-2.592 1.188C1.416 6.612 0 5.28 0 3.324V3.3C0 1.488 1.284 0 3.096 0zm-.012 1.188c-.888 0-1.512.684-1.644 1.668h3.252c-.096-.936-.648-1.668-1.608-1.668z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aL"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.432 0C4.86 0 5.688.96 5.688 2.424v4.044H4.236v-3.6c0-.984-.492-1.548-1.356-1.548-.84 0-1.428.588-1.428 1.572v3.576H0V.132h1.452v.972C1.86.516 2.448 0 3.432 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.312 0l8.312 16.624H0L8.312 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aN"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.312 0l8.312 16.624H0L8.312 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.312 0l8.312 16.624H0L8.312 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0v50H0V0h48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aQ"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.99 0c4.969 0 8.996 4.03 8.996 9a9.002 9.002 0 0 1-5.436 8.268c8.2 1.446 14.43 8.606 14.43 17.222V35H0v-.51c0-8.377 5.89-15.38 13.755-17.09A9.002 9.002 0 0 1 7.995 9c0-4.97 4.028-9 8.996-9z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(82.048 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECE200",
    d: "M0 0h170v114H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.048 1h148c6.075 0 11 4.925 11 11v92c0 6.075-4.925 11-11 11h-148c-6.075 0-11-4.925-11-11V12c0-6.075 4.925-11 11-11z",
    stroke: "#969696",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(82.048 23)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h170v92H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.048 104c0 6.075-4.925 11-11 11h-148c-6.075 0-11-4.925-11-11V23h170v81z",
    stroke: "#969696",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    transform: "translate(24.457 30.907)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h8.54v9.8H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(34.831 33.217)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.678v7.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "translate(43.54 33.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h11.242v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    transform: "translate(56.433 33.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "translate(14.004 89.117)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h8.862v9.8H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    transform: "translate(24.266 91.427)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.678v7.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)",
    transform: "translate(32.316 89.495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.62v9.548H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    transform: "translate(38.042 91.371)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "translate(50.698 91.371)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.882v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)",
    transform: "translate(59.742 88.613)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.578v10.304H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)",
    transform: "translate(31.952 102.697)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)",
    transform: "translate(41.374 102.781)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h1.82v10.136H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(45.35 105.382)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    transform: "translate(50.544 103.495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.62v9.548H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)",
    transform: "translate(56.886 102.697)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.636v10.22H0V0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)",
    transform: "translate(11.277 52.078)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.874v9.8H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)",
    transform: "translate(19.775 51.742)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h1.82v10.136H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)",
    transform: "translate(23.345 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.846v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)",
    transform: "translate(31.13 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)",
    transform: "translate(39.991 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.636v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)",
    transform: "translate(48.265 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.846v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)",
    transform: "translate(56.05 54.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)",
    transform: "translate(10.62 68.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.636v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    transform: "translate(19.215 68.486)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.65v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    transform: "translate(27.98 68.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h11.242v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)",
    transform: "translate(41.28 65.658)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)",
    transform: "translate(50.267 68.332)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)",
    transform: "translate(59.13 68.343)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#E)",
    transform: "translate(271.555 19.892)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h8.96v10.136H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#F)",
    transform: "translate(281.635 22.37)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.678v7.644H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#G)",
    transform: "translate(290.343 22.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#H)",
    transform: "translate(295.537 19.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#I)",
    transform: "translate(271.793 36.314)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.636v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#J)",
    transform: "translate(280.39 36.468)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.65v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#K)",
    transform: "translate(289.153 36.314)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h11.242v7.546H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#L)",
    transform: "translate(302.453 33.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.644v10.374H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#M)",
    transform: "translate(311.441 36.314)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.154v7.714H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#N)",
    transform: "translate(320.303 36.325)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h4.312v7.535H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#O)",
    transform: "translate(125.715 101.587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#P)",
    transform: "translate(133.47 101.671)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.288v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Q)",
    transform: "translate(137.11 100.555)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.684v11.112H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#R)",
    transform: "translate(143.427 101.587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#S)",
    transform: "translate(151.183 101.671)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.288v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#T)",
    transform: "translate(154.823 100.555)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.684v11.112H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#U)",
    transform: "translate(161.223 101.611)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.072v8.52H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)",
    transform: "translate(168.175 101.587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#W)",
    transform: "translate(176.363 101.587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#V)",
    transform: "translate(184.55 101.587)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#X)",
    transform: "translate(91.714 64.728)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.288v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Y)",
    transform: "translate(96.742 64.668)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.072v8.52H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Z)",
    transform: "translate(104.026 64.788)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.156v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)",
    transform: "translate(111.358 64.728)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.128v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)",
    transform: "translate(119.674 64.788)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.204v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)",
    transform: "translate(127.27 64.644)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.48v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)",
    transform: "translate(135.058 64.788)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.904v8.4H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae)",
    transform: "translate(142.006 64.668)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.408v8.64H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)",
    transform: "translate(114.128 7.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.4H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ag)",
    transform: "translate(123.092 9.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.132v6.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)",
    transform: "translate(129.86 9.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h9.576v6.408H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)",
    transform: "translate(143.924 7.48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.504v8.64H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)",
    transform: "translate(151.652 9.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.756v6.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)",
    transform: "translate(159.812 9.664)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.7v6.468H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)",
    transform: "translate(166.82 7.924)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.96v8.184H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#am)",
    transform: "translate(172.256 7.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.688v8.76H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)",
    transform: "translate(182.816 7.576)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h12.528v8.484H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ao)",
    transform: "translate(195.428 9.58)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.724v6.552H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)",
    transform: "translate(202.976 7.24)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h1.452v8.76H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aq)",
    transform: "translate(205.976 9.532)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.132v6.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)",
    transform: "translate(213.056 9.556)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.04v6.564H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)",
    transform: "translate(164.142 31.095)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.288v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)",
    transform: "translate(171.77 31.035)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.072v8.52H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)",
    transform: "translate(178.554 31.155)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.156v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)",
    transform: "translate(185.386 31.095)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.128v8.46H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)",
    transform: "translate(196.302 31.155)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.204v8.544H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)",
    transform: "translate(203.398 31.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.48v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)",
    transform: "translate(210.686 31.155)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.904v8.4H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)",
    transform: "translate(220.354 31.035)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.408v8.64H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aA)",
    transform: "translate(227.486 31.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.48v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aB)",
    transform: "translate(234.834 31.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.32v8.688H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aC)",
    transform: "translate(92.27 31.155)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.52v8.52H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aD)",
    transform: "translate(98.73 33.135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.724v6.552H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aE)",
    transform: "translate(104.853 33.219)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.504v8.292H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aF)",
    transform: "translate(115.001 31.01)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h7.68v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aG)",
    transform: "translate(123.585 30.867)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h1.56v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aH)",
    transform: "translate(125.99 31.479)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h3.96v8.184H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aI)",
    transform: "translate(130.95 30.867)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h1.56v8.688H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aJ)",
    transform: "translate(133.57 33.219)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.508v6.336H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aK)",
    transform: "translate(139.55 33.087)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h6.132v6.612H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aL)",
    transform: "translate(146.645 33.087)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#242934",
    d: "M0 0h5.688v6.468H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aM)",
    transform: "rotate(90 30.731 57.592)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B81236",
    d: "M0 0h16.624v16.624H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aN)",
    transform: "rotate(-90 144.793 -101.308)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B81236",
    d: "M0 0h16.624v16.624H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)",
    transform: "rotate(90 14.107 74.216)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B81236",
    d: "M0 0h16.624v16.624H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aO)",
    transform: "rotate(90 -4.393 92.716)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B81236",
    d: "M0 0h16.624v16.624H0V0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aP)",
    transform: "translate(194 46)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M0 0h48v50H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aQ)",
    transform: "translate(201.385 54.563)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C909B",
    d: "M0 0h34.98v35H0V0z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNswDriverLicence);
export default __webpack_public_path__ + "static/media/nsw_driver_licence.05dc5eef0ead664ea7eca3a8540cdf05.svg";
export { ForwardRef as ReactComponent };